// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_GRID_COPY_FILTER = "Skop\u00edrovat filtr";
export const BAZAAR_GRID_COPY_FILTER_PROMPT = "Skop\u00edruj si obsah filtra";
export const BAZAAR_GRID_COPY_FILTER_SUCCESS = "Filter bol skop\u00edrovan\u00fd do clipboardu.";
export const BZ2_COMMERCIAL_FIRST = "Plus a PRO na za\u010d\u00e1tku";
export const BZ2_counter_PRODUCTS = ["%(counter)s inzer\u00e1t", "%(counter)s inzer\u00e1ty", "%(counter)s inzer\u00e1t\u016f"];
export const BZ2_FILTER_SECTION_PRODUCTS_ALL = "V\u0161echny inzer\u00e1ty";
export const BZ2_FILTER_SECTION_PRODUCTS_FROM_LIKED_SELLERS = "Od m\u00fdch obl\u00edben\u00fdch";
export const BZ2_ONLY_NOT_MARKED = "Jen nezkontrolovan\u00e9";
export const BZ2_ONLY_REPORTED = "Pouze nahl\u00e1\u0161en\u00e9";
export const BZ2_SEARCH_IN = "Hledej v";
export const BZ2_SEARCH_IN_ALL_AND_USERS = "Hledej inzer\u00e1ty (nap\u0159. \"tenisky Adidas\", \"ko\u010d\u00e1rek Plze\u0148\") a prod\u00e1vaj\u00edc\u00ed (@loginprodavajiciho)";
